import { Construction } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

import { DASHBOARD_CAPABILITY_GAPS } from './constants'

/**
 * What this screen is catalogued to show and cannot yet — the dashboard's own version of
 * `AdminCapabilityGaps` and `LedgerCapabilityGaps`. Shown to everyone, unconditionally: this is a
 * gap in the API or in this pass, never in anyone's access, and there is no permission to gate it
 * behind.
 */
export function DashboardCapabilityGaps({ className }: { className?: string }) {
  return (
    <Card className={className}>
      <CardHeader>
        <div className="min-w-0">
          <CardTitle className="flex items-center gap-2">
            <Construction className="size-4 text-muted" aria-hidden />
            Not on this screen yet
          </CardTitle>
          <p className="mt-0.5 text-xs text-muted">
            Each of these is a gap in the API or in this pass, not in your access.
          </p>
        </div>
      </CardHeader>

      <CardContent>
        <dl className="space-y-4">
          {DASHBOARD_CAPABILITY_GAPS.map((gap) => (
            <div key={gap.title} className="min-w-0">
              <dt className="flex flex-wrap items-center gap-2">
                <span className="text-sm font-semibold text-heading">{gap.title}</span>
                <Badge tone="neutral" className="font-mono">
                  {gap.permission}
                </Badge>
              </dt>
              <dd className="mt-0.5 text-xs text-body">{gap.detail}</dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  )
}
